export default __webpack_public_path__ + "static/Logo-Lets-Celebrate-fulltext-1b7e9548a18fb83ee37e754f292665bc.svg";